import React from 'react';
import PropTypes from 'prop-types';
import styles from './IconWrapper.module.css';

/**
 * IconWrapper Component
 * Provides a consistent, theme-aware container for icons.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The icon component (e.g., Lucide icon)
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.themed - Preset theme color (e.g., 'primary', 'edit', 'delete')
 * @param {boolean} props.hoverable - Whether to apply hover effects
 * @param {Object} props.style - Additional inline styles
 */
const IconWrapper = ({
    children,
    className = '',
    themed = '',
    hoverable = false,
    style = {}
}) => {
    const combinedClasses = [
        styles.iconWrapper,
        themed ? styles[`themed-${themed}`] : '',
        hoverable ? styles.hoverable : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <span className={combinedClasses} style={style}>
            {children}
        </span>
    );
};

IconWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    themed: PropTypes.oneOf([
        'primary', 'secondary', 'edit', 'delete', 'view', 'save', 'cancel', 'warning', 'info', 'success', 'error', ''
    ]),
    hoverable: PropTypes.bool,
    style: PropTypes.object
};

export default IconWrapper;
